
define('text!templates/modules/setting/business/blocks/brand/brand-edit-content.html',[],function () { return '<div class="panel-body" id="brand-edit-content">\n    <ul class="menu-actions nav nav-pills"></ul>\n    <div class="alert-list"></div>\n    <div class="brand-edit-form"></div>\n    <div class="url-edit-form"></div>\n</div>\n';});

